<div class="padding">
  <mat-dialog-content style="min-width: 800px;">
    @if (!expandedItem) {
    
    <h3>
      <mat-icon class="counter-icon" color="primary">local_police</mat-icon>
      {{ 'partyPepsDialog.primarySanctionRecords' | transloco }}
    </h3>

    <p>{{ 'partyPepsDialog.primarySanctionsChecksIncludeListsThat' | transloco }}</p>

    @if (sanctionRecords.length > 0) {
      <table mat-table [dataSource]="sanctionRecords" multiTemplateDataRows
        class="fixed-table" data-testid="sanctions-table">
        <!-- Name Column -->
        <ng-container matColumnDef="name-on-record">
          <th mat-header-cell *matHeaderCellDef>{{ 'partyPepsDialog.nameOnRecord' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="name-on-record">{{ record.nameOnRecord }}</td>
        </ng-container>
        <!-- Alternate Names Column -->
        <ng-container matColumnDef="alternate-names">
          <th mat-header-cell *matHeaderCellDef>{{ 'partyPepsDialog.alternateNames' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="alternate-names">{{ record.alternateNames }}</td>
        </ng-container>
        <!-- Country Column -->
        <ng-container matColumnDef="country">
          <th mat-header-cell *matHeaderCellDef>{{ 'common.labels.country' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="country-text">{{ getCountryFull(record.country) }}.</td>
        </ng-container>
        <!-- Authority Column -->
        <ng-container matColumnDef="authority">
          <th mat-header-cell *matHeaderCellDef>{{ 'partyPepsDialog.authority' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="authority-text">{{ record.authority }}.</td>
        </ng-container>
        <!-- List Column -->
        <ng-container matColumnDef="list">
          <th mat-header-cell *matHeaderCellDef>{{ 'partyPepsDialog.listName' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="list-text">{{ record.listName }}.</td>
        </ng-container>
        <!-- Date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>{{ 'partyPepsDialog.dateOfPublication' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="date-text">{{ record.dateOfPublication | localizedDate }}</td>
        </ng-container>
        <!-- Currency Date Column -->
        <ng-container matColumnDef="currency-date">
          <th mat-header-cell *matHeaderCellDef>{{ 'partyPepsDialog.currencyDate' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="currency-date-text">{{ record.currencyDate | localizedDate }}</td>
        </ng-container>
        <ng-container matColumnDef="view">
              <th mat-header-cell *matHeaderCellDef [attr.aria-label]="'common.labels.rowActions' | transloco">&nbsp;</th>
              <td mat-cell *matCellDef="let record">
                <button mat-icon-button color="accent" (click)="viewDetails(record)"
                  [attr.aria-label]="'partyPepsDialog.viewDetails' | transloco">
                  <mat-icon>frame_inspect</mat-icon>
                </button>
              </td>
            </ng-container>
        <tr mat-header-row *matHeaderRowDef="this.sanctionsColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: this.sanctionsColumns;">
        </tr>
      </table>
    } @else {
      <lib-placeholder iconName="check_circle" iconClass="Success"
        [message]="'Not found on any Sanctions Lists'"
      [condition]="true"></lib-placeholder>
    }


    <mat-divider></mat-divider>

    <h3>
      <mat-icon class="counter-icon" color="primary">local_police</mat-icon>
      {{ 'partyPepsDialog.secondarySanctionRecords' | transloco }}
    </h3>

    <p>{{ 'partyPepsDialog.secondarySanctionsAreListsFromOther' | transloco }}</p>

    @if (secondarySanctionRecords.length > 0) {
      <table mat-table [dataSource]="secondarySanctionRecords" multiTemplateDataRows
        class="fixed-table" data-testid="sanctions-table">
        <!-- Name Column -->
        <ng-container matColumnDef="name-on-record">
          <th mat-header-cell *matHeaderCellDef>{{ 'partyPepsDialog.nameOnRecord' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="name-on-record">{{ record.nameOnRecord }}</td>
        </ng-container>
        <!-- Alternate Names Column -->
        <ng-container matColumnDef="alternate-names">
          <th mat-header-cell *matHeaderCellDef>{{ 'partyPepsDialog.alternateNames' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="alternate-names">{{ record.alternateNames }}</td>
        </ng-container>
        <!-- Authority Column -->
        <ng-container matColumnDef="authority">
          <th mat-header-cell *matHeaderCellDef>{{ 'partyPepsDialog.authority' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="authority-text">{{ record.authority }}.</td>
        </ng-container>
        <!-- Country Column -->
        <ng-container matColumnDef="country">
          <th mat-header-cell *matHeaderCellDef>{{ 'common.labels.country' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="country-text">{{ getCountryFull(record.country) }}.</td>
        </ng-container>
        <!-- List Column -->
        <ng-container matColumnDef="list">
          <th mat-header-cell *matHeaderCellDef>{{ 'partyPepsDialog.listName' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="list-text">{{ record.listName }}.</td>
        </ng-container>
        <!-- Date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>{{ 'partyPepsDialog.dateOfPublication' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="date-text">{{ record.dateOfPublication | localizedDate }}</td>
        </ng-container>
        <!-- Currency Date Column -->
        <ng-container matColumnDef="currency-date">
          <th mat-header-cell *matHeaderCellDef>{{ 'partyPepsDialog.currencyDate' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="currency-date-text">{{ record.currencyDate | localizedDate }}</td>
        </ng-container>
        <ng-container matColumnDef="view">
              <th mat-header-cell *matHeaderCellDef [attr.aria-label]="'common.labels.rowActions' | transloco">&nbsp;</th>
              <td mat-cell *matCellDef="let record">
                <button mat-icon-button color="accent" (click)="viewDetails(record)"
                  [attr.aria-label]="'partyPepsDialog.viewDetails' | transloco">
                  <mat-icon>frame_inspect</mat-icon>
                </button>
              </td>
            </ng-container>
        <tr mat-header-row *matHeaderRowDef="this.sanctionsColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: this.sanctionsColumns;">
        </tr>
      </table>
    } @else {
      <lib-placeholder iconName="check_circle" iconClass="Success"
        [message]="'Not found on any Other Sanctions Lists'"
      [condition]="true"></lib-placeholder>
    }

    <mat-divider></mat-divider>

    <h3>
      <mat-icon class="counter-icon" color="primary">person_alert</mat-icon>
      {{ 'partyPepsDialog.politicallyExposedPersonRecords' | transloco }}
    </h3>

    @if (pepsRecords.length > 0) {
      <table mat-table [dataSource]="pepsRecords" multiTemplateDataRows
        class="fixed-table" data-testid="peps-table">
        <!-- Name Column -->
        <ng-container matColumnDef="name-on-record">
          <th mat-header-cell *matHeaderCellDef>{{ 'partyPepsDialog.nameOnRecord' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="name-on-record">{{ record.nameOnRecord }}</td>
        </ng-container>
        <!-- Alternate Names Column -->
        <ng-container matColumnDef="alternate-names">
          <th mat-header-cell *matHeaderCellDef>{{ 'partyPepsDialog.alternateNames' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="alternate-names">{{ record.alternateNames }}</td>
        </ng-container>
        <!-- Authority Column -->
        <ng-container matColumnDef="position">
          <th mat-header-cell *matHeaderCellDef>{{ 'partyPepsDialog.position' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="position-text">{{ record.position }}.</td>
        </ng-container>
        <!-- List Column -->
        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef>{{ 'partyPepsDialog.category' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="category-text">{{ record.category }}.</td>
        </ng-container>
        <!-- Date Column -->
        <ng-container matColumnDef="end-date">
          <th mat-header-cell *matHeaderCellDef>{{ 'common.labels.endDate' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="end-date-text">{{ record.endDate | localizedDate }}</td>
        </ng-container>
        <!-- Currency Date Column -->
        <ng-container matColumnDef="currency-date">
          <th mat-header-cell *matHeaderCellDef>{{ 'partyPepsDialog.currencyDate' | transloco }}</th>
          <td mat-cell *matCellDef="let record" data-testid="currency-date-text">{{ record.currencyDate | localizedDate }}</td>
        </ng-container>
        <ng-container matColumnDef="view">
              <th mat-header-cell *matHeaderCellDef [attr.aria-label]="'common.labels.rowActions' | transloco">&nbsp;</th>
              <td mat-cell *matCellDef="let record">
                <button mat-icon-button color="accent" (click)="viewDetails(record)"
                  [attr.aria-label]="'partyPepsDialog.viewDetails' | transloco">
                  <mat-icon>frame_inspect</mat-icon>
                </button>
              </td>
            </ng-container>
        <tr mat-header-row *matHeaderRowDef="this.pepsColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: this.pepsColumns;">
        </tr>
      </table>
    } @else {
      <lib-placeholder iconName="check_circle" iconClass="Success"
        [message]="'No indicators of a Politcially Exposed Person found'"
      [condition]="true"></lib-placeholder>
    }
  } @else {
    <h3>
      <mat-icon class="counter-icon" color="primary">frame_inspect</mat-icon>
      {{ recordType }}
    </h3>

    @if (this.fullDetails?.Name_of_the_List) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.nameOfList' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Name_of_the_List }}</span>
    </div>
    }

    @if (this.fullDetails?.Type_of_List) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.typeOfList' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Type_of_List }}</span>
    </div>
    }

    @if (this.fullDetails?.Country_Of_Origin) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.countryOfOrigin' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Country_Of_Origin }}</span>
    </div>
    }

    @if (this.fullDetails?.Country_Of_Activity) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.countryOfActivity' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Country_Of_Activity }}</span>
    </div>
    }

    @if (this.fullDetails?.Date_of_Publication_of_the_List || this.fullDetails?.Date_of_Publication) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.listPublicationDate' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Date_of_Publication_of_the_List ?? fullDetails.Date_of_Publication }}</span>
    </div>
    }

    @if (this.fullDetails?.Date_of_Information) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.dateOfInformation' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Date_of_Information }}</span>
    </div>
    }

    @if (this.fullDetails?.Country) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.country' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Country }}</span>
    </div>
    }

    @if (this.fullDetails?.Category) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.category2' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Category }}</span>
    </div>
    }

    @if (this.fullDetails?.Authority) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.authority2' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Authority }}</span>
    </div>
    }

    @if (this.fullDetails?.Title) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.title' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Title }}</span>
    </div>
    }

    @if (this.fullDetails?.Gender) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.gender' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Gender }}</span>
    </div>
    }

    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.firstName' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.First_Name }}</span>
    </div>

    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.lastName' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Last_Name }}</span>
    </div>

    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.fullName' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Full_Name }}</span>
    </div>

    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.otherNames' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Other_Names }}</span>
    </div>

    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.dob' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.DOB }}</span>
    </div>

    @if (this.fullDetails?.POB) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.pob' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.POB }}</span>
    </div>
    }

    @if (this.fullDetails?.Entity_Type) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.entityType' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Entity_Type }}</span>
    </div>
    }

    @if (this.fullDetails?.Type_SDN_or_Entity) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.typeSdnOrEntity' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Type_SDN_or_Entity }}</span>
    </div>
    }

    @if (this.fullDetails?.Function) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.function' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Function }}</span>
    </div>
    }

    @if (this.fullDetails?.Specificfunction) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.specificFunction' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Specificfunction }}</span>
    </div>
    }

    @if (this.fullDetails?.No_longer_on_List) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.noLongerOnList' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.No_longer_on_List }}</span>
    </div>
    }

    @if (this.fullDetails?.Date_Not_In_Charge_Since) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.noLongerInChargeDate' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Date_Not_In_Charge_Since }}</span>
    </div>
    }

    @if (this.fullDetails?.Alternative_Script) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.alternativeScript' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Alternative_Script }}</span>
    </div>
    }

    @if (this.fullDetails?.Address) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.address' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Address }}</span>
    </div>
    }

    @if (this.fullDetails?.Address_Country) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.addressCountry' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Address_Country }}</span>
    </div>
    }

    @if (this.fullDetails?.Passsport_Nr) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.passsport' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Passsport_Nr }}</span>
    </div>
    }

    @if (this.fullDetails?.ExPEPs) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.exPeps' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.ExPEPs }}</span>
    </div>
    }

    @if (this.fullDetails?.Whitelist) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.whitelist' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Whitelist }}</span>
    </div>
    }

    @if (this.fullDetails?.Additional_Information) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.additionalInformation' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Additional_Information }}</span>
    </div>
    }

    @if (this.fullDetails?.Case) {
    <div class="flex-container">
      <span class="flex-item bold">{{ 'partyPepsDialog.case' | transloco }}</span>
      <span class="flex-item-2">{{ fullDetails.Case }}</span>
    </div>
    }
  }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    @if (!expandedItem) {
      <button mat-raised-button color="primary" [mat-dialog-close]="true">
        {{ 'common.buttons.close' | transloco }}
      </button>
    } @else {
      <button mat-raised-button color="primary" (click)="downloadDetails()">
        {{ 'partyPepsDialog.downloadJson' | transloco }}
      </button>
      <span class="spacer"></span>
      <button mat-raised-button color="primary" (click)="exitDetails()">
        {{ 'partyPepsDialog.back' | transloco }}
      </button>
    }
  </mat-dialog-actions>
</div>